"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      filterForm: {
        template: null
      },
      isSelectList: [{
        value: 'KR_CHECK',
        label: 'KR_CHECK'
      }, {
        value: 'KR_ATTACHE',
        label: 'KR_ATTACHE'
      }, {
        value: 'KR_COPY_BLANK',
        label: 'KR_COPY_BLANK'
      }, {
        value: 'DOOR_ORDER_SHEET',
        label: 'DOOR_ORDER_SHEET'
      }],
      rules: {
        template: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      this.filterForm.template = null;
    },
    handleClose: function handleClose() {
      this.$parent.viewVisible = false;
    },
    handleSubimtSign: function handleSubimtSign() {
      var _this = this;
      this.$refs.filterForm.validate(function (valid) {
        if (valid) {
          var data = {
            bookingHeadWebComId: _this.id,
            template: _this.filterForm.template
          };
          (0, _booking.getUrlStrForPreviewKR)(data).then(function (res) {
            if (res.success) {
              if (res.data) {
                window.open(res.data);
              } else {
                _this.$message({
                  message: _this.$t('home.previewFailed'),
                  type: 'error'
                });
              }
            }
          });
        }
      });
    },
    handleSubimt: function handleSubimt() {
      var _this2 = this;
      this.$refs.filterForm.validate(function (valid) {
        if (valid) {
          _this2.filterForm.copyId = _this2.copyId;
          _this2.filterForm.copyCount = _this2.filterForm.copyCount + '';
          _this2.filterForm.bkType = _this2.filterForm.bkType + '';
          console.log(_this2.filterForm, (0, _typeof2.default)(_this2.filterForm.copyCount));
          saveOrUpdateByMutiCopy(_this2.filterForm).then(function (res) {
            if (res.success) {
              _this2.$message({
                message: _this2.$t('home.copySuccess'),
                type: 'success'
              });
              _this2.$parent.copyVisible = false;
            }
          });
        }
      });
    },
    handleSearch: function handleSearch() {
      var _this3 = this;
      queryListVoyagePlan(this.filterForm).then(function (res) {
        _this3.tableData = res.data.records;
        _this3.total = res.data.totalRecord;
      });
    }
  }
};